/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import generatedGitInfo from './generatedGitInfo.json';

const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL as string;
const BASE_MEDIA_URL = import.meta.env.VITE_BASE_MEDIA_URL as string;
const BASE_QUESTION_MEDIA_URL = import.meta.env.VITE_BASE_QUESTION_MEDIA_URL as string;
const BASE_APP_URL = import.meta.env.VITE_BASE_APP_URL as string;
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT as string;

const GET_SERVER_TIME_URL = `${AUTH_BASE_URL}/auth/get-server-time`;
const APP_VERSION = generatedGitInfo.version_code;
const GIT_INFO = `${generatedGitInfo.gitBranch}-${generatedGitInfo.gitCommitHash}`;

const VALIDATE_CENTER_URL = `${AUTH_BASE_URL}/admin/auth/validate-center`;
const ADMIN_LOGIN_URL = `${AUTH_BASE_URL}/admin/auth/login`;
const REFRESH_TOKEN_URL = `${AUTH_BASE_URL}/admin/auth/get-device-access-token`;
const ADMIN_LOGOUT_URL = `${AUTH_BASE_URL}/admin/auth/logout`;
const GET_ADMIN_DETAILS = `${AUTH_BASE_URL}/admin/program/get-details`;
const SUBMIT_ADMIN_FEEDBACK = `${AUTH_BASE_URL}/admin/support/submit-feedback`;
const RESET_APP = `${AUTH_BASE_URL}/admin/auth/reset-app`;

const GET_GRADES_URL = `${AUTH_BASE_URL}/student/program/get-grades`;
const GET_STUDENTS_URL = `${AUTH_BASE_URL}/student/center/get-students-by-grade`;
const GET_STUDENT_DETAILS = `${AUTH_BASE_URL}/student/program/get-details`;

const SET_STUDENT_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/set-password`;
const CHECK_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/check-password`;
const LOGIN_STUDENT_URL = `${AUTH_BASE_URL}/student/auth/login`;
const GET_RESET_PASSWORD_TOKEN_URL = `${AUTH_BASE_URL}/student/auth/get-reset-password-token`;
const RESET_PASSWORD_URL = `${AUTH_BASE_URL}/student/auth/reset-password`;

const GET_INSTRUCTIONS_URL = `${AUTH_BASE_URL}/student/assessment/get-instructions`;
const CHECK_AVAILABILITY_URL = `${AUTH_BASE_URL}/student/assessment/check-availability`;
const INITIATE_TEST_URL = `${AUTH_BASE_URL}/student/assessment/initiate`;
const REJOIN_TEST_URL = `${AUTH_BASE_URL}/student/assessment/rejoin`;
const SUBMIT_RESPONSE_URL = `${AUTH_BASE_URL}/student/assessment/submit-response`;
const SUBMIT_ASSESSMENT_URL = `${AUTH_BASE_URL}/student/assessment/submit`;
const ABORT_ASSESSMENT_URL = `${AUTH_BASE_URL}/student/assessment/abort`;
const GET_STUDENT_INFO = `${AUTH_BASE_URL}/student/info`;
const SUBMIT_STUDENT_FEEDBACK = `${AUTH_BASE_URL}/student/support/submit-feedback`;

const GET_SUBJECT_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-subject-list`;
const GET_LEVEL_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-level-list`;
const GET_MISSION_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-mission-list`;
const GET_STAGE_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-stage-list`;
const GET_MODULE_LIST_URL = `${AUTH_BASE_URL}/student/learn/get-module-list`;
const ADD_MODULE_STATS_URL = `${AUTH_BASE_URL}/student/learn/add-module-stats`;

const GET_STATS_URL = `${AUTH_BASE_URL}/student/cueing-engine/get-stats`;
const GET_QUESTIONS_URL = `${AUTH_BASE_URL}/student/cueing-engine/get-questions`;
const SUBMIT_RESULT_URL = `${AUTH_BASE_URL}/student/cueing-engine/submit-result`;

const GET_PRACTICE_CONTENT_URL = `${AUTH_BASE_URL}/student/practice/get-content`;
const SUBMIT_PRACTICE_RESULT_URL = `${AUTH_BASE_URL}/student/practice/submit-result`;

const GET_MEDIA_ACCESS_TOKEN_URL = `${AUTH_BASE_URL}/student/auth/get-media-access-token`;
const GET_MODULE_DETAILS_URL = `${AUTH_BASE_URL}/student/content/get-module-details`;

const SPLASH_SCREEN_TIME = 2000;
const AUTO_LOGOUT_TIME = 600e3;

const FAQ_URL = 'https://convegeniusglobal.zohodesk.com/portal/en/kb';

export default {
  AUTH_BASE_URL,
  BASE_MEDIA_URL,
  BASE_QUESTION_MEDIA_URL,
  CONNECTION_TIMEOUT: 1.25 * 60 * 1000,
  VALIDATE_CENTER_URL,
  ADMIN_LOGIN_URL,
  GET_GRADES_URL,
  GET_STUDENTS_URL,
  SET_STUDENT_PASSWORD_URL,
  CHECK_PASSWORD_URL,
  LOGIN_STUDENT_URL,
  GET_RESET_PASSWORD_TOKEN_URL,
  RESET_PASSWORD_URL,
  REFRESH_TOKEN_URL,
  ADMIN_LOGOUT_URL,
  SPLASH_SCREEN_TIME,
  GET_SUBJECT_LIST_URL,
  GET_INSTRUCTIONS_URL,
  CHECK_AVAILABILITY_URL,
  INITIATE_TEST_URL,
  REJOIN_TEST_URL,
  SUBMIT_RESPONSE_URL,
  SUBMIT_ASSESSMENT_URL,
  ABORT_ASSESSMENT_URL,
  GET_LEVEL_LIST_URL,
  GET_MISSION_LIST_URL,
  GET_STAGE_LIST_URL,
  GET_MODULE_LIST_URL,
  ADD_MODULE_STATS_URL,
  GET_STATS_URL,
  GET_QUESTIONS_URL,
  SUBMIT_RESULT_URL,
  SUBMIT_PRACTICE_RESULT_URL,
  GET_PRACTICE_CONTENT_URL,
  GET_SERVER_TIME_URL,
  GET_STUDENT_INFO,
  SUBMIT_STUDENT_FEEDBACK,
  GET_ADMIN_DETAILS,
  GET_STUDENT_DETAILS,
  SUBMIT_ADMIN_FEEDBACK,
  RESET_APP,
  AUTO_LOGOUT_TIME,
  GET_MEDIA_ACCESS_TOKEN_URL,
  GET_MODULE_DETAILS_URL,
  FAQ_URL,
  BASE_APP_URL,
  APP_VERSION,
  GIT_INFO,
  ENVIRONMENT,
};
